import deleteSessionStorageData from './storage/delete-session-storage-data';
import getSessionStorageData from './storage/get-session-storage-data';
import testSessionStorage from './storage/test-session-storage';

import config from './config/config';
import setSessionStorageData from './storage/set-session-storage-data';

function IPGeo(options) {
  var internalOptions = options || {};
  this.service = internalOptions.service || 'geojs';
}

IPGeo.prototype.getGeo = function () {
  var serviceObj = config[this.service];

  if (testSessionStorage()) {
    var sessionStorageData = getSessionStorageData();
    if (sessionStorageData) {
      return sessionStorageData;
    }
  }

  return fetch(serviceObj.url)
    .then(function (data) {
      return data.json()
    })
    .then(function (data) {
      if (testSessionStorage()) {
        setSessionStorageData(data);
      }
      return data;
    });
}

IPGeo.prototype.removeSessionGeoData = function () {
  if (testSessionStorage()) {
    deleteSessionStorageData();
  }
}

export default IPGeo;
